import { IDs } from '../../helpers/IDs';
import parse from 'html-react-parser';
import * as React from 'react';
import style from './Zertifizierung.less';
import { WArchivImage } from '../../core/elements/WArchivImage';

interface ZusatztoolsZertifizierungOptionenProps {
    data: any;
}

interface ZusatztoolsZertifizierungOptionenState {
    onMouseOver: number;
}

export class ZusatztoolsZertifizierungOptionen extends
    React.Component<ZusatztoolsZertifizierungOptionenProps, ZusatztoolsZertifizierungOptionenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            onMouseOver: null
        };
    }

    render(): JSX.Element {
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div className={style.optionen}>
                    {this.renderOptionen()}
                </div>
                {this.renderErlaeuterung()}
                {/* {(this.state.onMouseOver || true) && this.renderErlaeuterung()} */}
            </div>
        );
    }

    renderErlaeuterung(): JSX.Element {
        const data: any = ((this.props.data[IDs.ENT_ZERTIFIZIERUNGSOPTIONEN] || [])
            .find((item: any) => (item.tid || null) === this.state.onMouseOver)) || {};
        const erlaeuterung = parse(data.erlaeuterung || '');

        return <div>{erlaeuterung}</div>;
    }

    renderOptionen(): JSX.Element {
        const bereich_key: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key || null;
        const blacklist: any[] = [];
        const optionen: JSX.Element[] = [];
        const whitelist: any[] = [];

        (this.props.data[IDs.ENT_ZERTIFIZIERUNG_ZUORDNUNG] || []).forEach((item: any) => {
            if ((item.bereich_key_orig || item.bereich_key) === bereich_key && item.zertifizierung) {
                whitelist.push(item.zertifizierung_orig || item.zertifizierung);
            } else if (typeof (item.bereich_key_orig || item.bereich_key) !== 'undefined' && item.zertifizierung) {
                blacklist.push(item.zertifizierung_orig || item.zertifizierung);
            }
        });
        const data: any[] = (this.props.data[IDs.ENT_ZERTIFIZIERUNGSOPTIONEN] || [])
            .filter((item: any) => whitelist.indexOf(item.tid) !== -1 || blacklist.indexOf(item.tid) === -1);

        data.forEach((option: any, index: number) => {
            const text = option.text;
            const split = text.split(':', 2);
            let content: any = text;
            if (split.length === 2) {
                content = <React.Fragment>{split[0].trim()}: <br /> {split[1].trim()}</React.Fragment>;
            }
            optionen.push(
                <a
                    key={`option-${index}`}
                    href={option.link || '#'}
                    target={option.link ? '_blank' : null}
                    onMouseEnter={() => this.setState({ onMouseOver: option.tid || null })}
                    // onMouseLeave={() => this.setState({ onMouseOver: null })}
                >
                    <div style={{ ...(option.tid === this.state.onMouseOver && { fontWeight: 'bold' }) }}>
                        <WArchivImage archivId={option.logo || null} />
                        <div>{content}</div>
                    </div>
                </a>
            );
        });
        return <div>{optionen}</div>;
    }
}
